




































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
// import ParagraphImage from "@/components/cms/elements/ParagraphImage";
import ParagraphFullhtml from "@/general/components/cms/elements/ParagraphFullhtml.vue";
import ParagraphHeading from "@/general/components/cms/elements/ParagraphHeading.vue";
// import ParagraphHierarchicalBlock from "@/components/cms/elements/ParagraphHierarchicalBlock";
// import ParagraphButton from "@/components/cms/elements/ParagraphButton";
// import ParagraphList from "@/components/cms/elements/ParagraphList";
// import ParagraphImageText from "@/components/cms/elements/ParagraphImageText";

import TopPageApi from "@/general/api/topPageApi";

@Component({
  name: "Cms",
  components: {
    // ParagraphImage,
    ParagraphFullhtml,
    ParagraphHeading
    // ParagraphHierarchicalBlock,
    // ParagraphButton,
    // ParagraphList,
    // ParagraphImageText,
  }
})
export default class BlockContents extends Vue {
  @Prop({ type: String, default: "" }) location_code!: string;

  error: string | null = null;
  element_type = null;
  CMS_response = null;
  ApiResponse = {
    data: {},
    isError: false
  };
  isLoading = true;

  @Watch("location_code")
  async onReadcms() {
    this.element_type = null;
    this.CMS_response = null;
    await this.readcms();
    this.isLoading = false;
  }

  async created() {
    await this.readcms();
    this.isLoading = false;
  }

  async readcms() {
    const APIres = await TopPageApi.getBlockContents({
      locationCode: this.location_code,
      contractID: null,
      courseID: null
    });
    this.ApiResponse.data = APIres;
    return this.setResponse(this.ApiResponse);
  }

  setResponse(obj: any) {
    if (
      !obj ||
      !obj.data ||
      !obj.data.data ||
      !obj.data.included ||
      !obj.data.included[0] ||
      !obj.data.data[0] ||
      !obj.data.data[0].relationships ||
      !obj.data.data[0].relationships.paragraphs ||
      !obj.data.data[0].relationships.paragraphs.data ||
      !obj.data.data[0].relationships.paragraphs.data[0] ||
      !obj.data.data[0].relationships.paragraphs.data[0].id
    ) {
      return;
    }
    // obj.data.data[0].relationships.paragraphs.data[0].idと、include[n].idを比較
    // 一致する物のみを画面に表示するために、include配列をフィルターする
    const data_id = obj.data.data[0].relationships.paragraphs.data[0].id;
    obj.data.included = obj.data.included.filter(
      (item: any) => item.id === data_id
    );

    if (obj.data.included.length !== 1) {
      this.error = "コンテンツの読み込みに失敗しました";
      return;
    }

    const type = obj.data.included[0].type;
    this.element_type = type;
    this.CMS_response = obj.data;
  }
}
